// extracted by mini-css-extract-plugin
module.exports = {"error":"DonationUserProfileSection_error__3nuwI"};